import { render, staticRenderFns } from "./protocol_item_construct.vue?vue&type=template&id=b6c3bfd2"
import script from "./protocol_item_construct.vue?vue&type=script&lang=js"
export * from "./protocol_item_construct.vue?vue&type=script&lang=js"
import style0 from "./protocol_item_construct.vue?vue&type=style&index=0&id=b6c3bfd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports